import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardPatchRest } from './api/helpers/boardPatchRest';

export const boardSetCardNumberEnabled = (
    boardId: TBoardId,
    cardNumberEnabled: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardPatchRest(boardId, {cardNumberEnabled}));
    };
    return action;
}
